export enum MachineAssignmentShift {
  Matutino = 0,
  Nocturno = 1,
}

export interface MachineAssignmentShiftOption {
  label: string;
  value: MachineAssignmentShift;
}
